// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__T8dDK","Div":"CustomFadeBox_Div__1Hyfb","LargeDiv":"CustomFadeBox_LargeDiv__dculv"};